import { Actions as INTEGRATION_ACTIONS } from "@/redux/actions/integrationActions";
import { MagnifyingGlassIcon } from "@heroicons/react/20/solid";
import { useEffect, useMemo } from "react";
import { connect } from "react-redux";
// import CreatableSelect from "react-select/async-creatable";
import AsyncSelect from "react-select/async";
import { INTEGRATION_NAME, INTEGRATION_TYPE, INTEGRATION_VARIABLE } from "./store/config";
import { Actions as SMART_PENSION_ACTIONS } from "./store/smartPensionActions";

const SmartPensionEmployeeLink = ({
	agreement,
	thirdPartyList,
	thirdPartyContact,
	creatingEmployee,
	getSmartPensionEmployees,
	desyncingEmployee,
	disabled,
	loadingEmployees,
	switchEmployeeLink,
	size,
}) => {
	useEffect(() => {
		if (!thirdPartyList) getSmartPensionEmployees();
	}, []);

	// const handleCreate = (inputValue) => {
	// 	const data = {};

	// 	if (!agreement) data.name = inputValue;
	// 	else data.agreement = agreement;

	// 	createSmartPensionEmployee(data);
	// };

	const placeholder = useMemo(() => {
		if (desyncingEmployee) return "Desyncing Employee...";
		if (loadingEmployees) return "Loading Employee...";
		if (creatingEmployee) return "Creating Employee...";

		return (
			<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
				<div>Search</div>
				<MagnifyingGlassIcon style={{ height: "2rem", display: "block", paddingRight: "2rem" }} />
			</div>
		);
	}, [loadingEmployees, creatingEmployee, desyncingEmployee]);

	return (
		<>
			<div className={`col-xs-${size ? `${size}` : "3"}`}>
				<div className={agreement ? "form-material form-container" : null}>
					<label htmlFor="material-text">{INTEGRATION_NAME} Link</label>
					<AsyncSelect
						isDisabled={disabled || creatingEmployee || desyncingEmployee}
						allowCreateWhileLoading={false}
						// formatCreateLabel={(inputValue) =>
						// 	`Create "${agreement ? `${givenName} ${familyName}` : inputValue}"`
						// }
						name="smartPension-thirdPartyLink"
						classNamePrefix="react-select-search"
						createOptionPosition="last"
						isClearable
						isLoading={creatingEmployee || loadingEmployees}
						// onCreateOption={handleCreate}
						menuPlacement="auto"
						onMenuOpen={getSmartPensionEmployees}
						defaultOptions={thirdPartyList}
						value={thirdPartyContact}
						onChange={(selected) => {
							switchEmployeeLink(selected?.value || "desynced");
						}}
						placeholder={placeholder}
					/>
				</div>
			</div>
		</>
	);
};

const mapStateToProps = (state, ownProps) => {
	const agreementInfo = ownProps.agreementInfo ? ownProps.agreementInfo : state.employee.agreementInfo;
	const { id: agreement, employeeDetails } = agreementInfo || {};

	const { smartPension } = state?.integration?.pension || {};

	const { desyncingEmployee, creatingEmployee, loadingEmployees, links, employees } = smartPension || {};

	const thirdPartyList = employees?.map((item) => ({
		label: `${item?.firstName} ${item?.lastName}`,
		value: item?.id,
	}));

	const thirdPartyId =
		state.employee?.smartPensionLink ||
		state?.integration?.[INTEGRATION_TYPE]?.[INTEGRATION_VARIABLE]?.links?.find?.(
			(e) => e?.agreement == agreementInfo?.id,
		)?.link;

	const thirdPartyContact = thirdPartyList?.find?.((e) => e?.value == thirdPartyId);

	return {
		agreement,
		employeeDetails,
		creatingEmployee,
		desyncingEmployee,
		loadingEmployees,
		thirdPartyList,
		thirdPartyContact,
	};
};

const mapDispatchToProps = (dispatch) => ({
	getSmartPensionEmployees: () => dispatch(SMART_PENSION_ACTIONS.getSmartPensionEmployees()),
	// createSmartPensionEmployee: ({ agreement, name }) =>
	// 	dispatch(SMART_PENSION_ACTIONS.createSmartPensionEmployee({ agreement, name })),
	switchEmployeeLink: (employee) => dispatch(INTEGRATION_ACTIONS.switchEmployeeLink(employee, "smartPension")),
});

export default connect(mapStateToProps, mapDispatchToProps)(SmartPensionEmployeeLink);
